import React from 'react';

import { ManagedRuntime } from 'effect';
import { LiveManagedRuntime } from 'services/layer';

export type RuntimeContext = ManagedRuntime.ManagedRuntime.Context<LiveManagedRuntime>;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RuntimeContext = React.createContext<LiveManagedRuntime | null>(null);
